
  @if (isParent) {
         
      <app-radio-input [label]="otherChildrenQuestionText" shortLabel="Other Children"
        [control]="nonIncludedChildrenForm.controls.childrenNotIncluded"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
        [submitAttempted]="submitAttempted">

      </app-radio-input>
     
  

    @if (nonIncludedChildrenForm.get('childrenNotIncluded')?.value === 'true') {
      <div>
       
        <div class="section-label">
          <mat-label class="control-label">List all children not included</mat-label>
        </div>
        
        @if (safeChildrenNotIncludedList.length > 0) {

          @if(!(isMobile$ | async)) {

            <table mat-table [dataSource]="safeChildrenNotIncludedList" class="mat-elevation-z1">
              
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef style="width: 25%;">Name</th>
                <td mat-cell *matCellDef="let child">
                  {{getTitle(child)}} {{child.firstName}} {{child.surname}}
                </td>
              </ng-container>

              <!-- DOB Column -->
              <ng-container matColumnDef="dob">
                <th mat-header-cell *matHeaderCellDef style="width: 25%;">DOB</th>
                <td mat-cell *matCellDef="let child">{{child.dob | date:'dd/MM/yyyy'}}</td>
              </ng-container>

              <!-- Country of Residence Column -->
              <ng-container matColumnDef="countryResidence">
                <th mat-header-cell *matHeaderCellDef style="width: 35%;">Country of Residence</th>
                <td mat-cell *matCellDef="let child">{{child.countryResidence?.value}}</td>
              </ng-container>

              <!-- Edit Column -->
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef style="width: 5%;">Edit</th>
                <td mat-cell *matCellDef="let child; let i = index">
                  <button mat-icon-button (click)="edit(i)" aria-label="Edit child">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>

              <!-- Delete Column -->
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef style="width: 5%;">Delete</th>
                <td mat-cell *matCellDef="let child; let i = index">
                  <button mat-icon-button (click)="remove(i)" aria-label="Delete child" color="warn">
                    <mat-icon>close</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        }
        @if(isMobile$ | async){
          <div class="mobile-cards">
            @for(child of safeChildrenNotIncludedList; track child; let i = $index) {
              <mat-card  class="mobile-card">
                <mat-card-content>
                  <div class="mobile-card-details">
                    <div class="mobile-card-item">
                      <span class="label">Name:</span>
                      <span class="value">{{child.firstName}} {{child.surname}}</span>
                    </div>
                    <div class="mobile-card-item">
                      <span class="label">DOB:</span>
                      <span class="value">{{child.dob | date:'dd/MM/yyyy'}}</span>
                    </div>
                    @if(child.countryResidence) {
                    <div class="mobile-card-item">
                      <span class="label">Country of Residence:</span>
                      <span class="value">{{child.countryResidence.value}}</span>
                    </div>
                    }
                  </div>
                  <div class="mobile-card-actions">
                    <button mat-stroked-button (click)="edit(i)" class="action-button">
                      <mat-icon>edit</mat-icon>
                      Edit
                    </button>
                    <button mat-stroked-button color="warn" (click)="remove(i)" class="action-button">
                      <mat-icon>delete</mat-icon>
                      Delete
                    </button>
                  </div>
                </mat-card-content>
              </mat-card>
            }
          </div>
        }

        }
        <button mat-raised-button color="primary" (click)="add()">Add Child</button>

      </div>
    }

  }
